import React from 'react';
import './Header.css';

const Header: React.FC = () => {
  return (
    <header className="sticky-header">
      <h2>Företagsevent - Skrattyoga</h2>
    </header>
  );
};

export default Header;